import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import { useLocation } from "react-router-dom";
import QrLogin from "./QrLogin";
import "./YouTubeClone.css";
import { videoData } from "./videoData";

const YouTubeClone = () => {
  const location = useLocation();
  const { video, sectionTitle, num } = location.state;
  const iframeContainerRef = useRef(null);
  const [player, setPlayer] = useState(null);
  const [isLoginVisible, setIsLoginVisible] = useState(false);
  const [videoDetails, setVideoDetails] = useState(video);

  const handleCloseLoginForm = () => {
    setIsLoginVisible(false);
  };

  const loadYouTubePlayer = (videoId) => {
    const initializePlayer = () => {
      if (iframeContainerRef.current) {
        const newPlayer = new window.YT.Player(iframeContainerRef.current, {
          videoId,
          events: {
            onStateChange: handlePlayerStateChange,
          },
        });
        setPlayer(newPlayer);
      }
    };

    if (!window.YT || !window.YT.Player) {
      const script = document.createElement("script");
      script.src = "https://www.youtube.com/iframe_api";
      script.async = true;
      script.onload = () => {
        window.onYouTubeIframeAPIReady = initializePlayer;
      };
      document.body.appendChild(script);
    } else {
      initializePlayer();
    }
  };

  const handlePlayerStateChange = (event) => {
    const auth = localStorage.getItem("Authenticated");
    if (event.data === window.YT.PlayerState.PLAYING) {
      if (auth !== "true") {
        event.target.pauseVideo();
        setIsLoginVisible(true);
      }
    }
  };

  useEffect(() => {
    if (video?.url) {
      const urlObj = new URL(video.url);
      const videoId = urlObj.searchParams.get("v");
      loadYouTubePlayer(videoId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [video]);

  const styles = {
    componentContainer: {
      backgroundColor: "#fffc00",
      padding: "20px 0",
    },
    maincard: {
      border: "1px solid rgba(255, 0, 0, 0.1)",
      padding: "20px",
      backgroundColor: "rgba(255, 252, 0, 0.5)",
      borderRadius: "14px",
      margin: "10px",
    },
    section: {
      margin: "20px 0",
      padding: "0 250px",
    },
    sectionTitle: {
      fontSize: "1.5rem",
      marginBottom: "10px",
      color: "#FF0000",
      marginLeft: "15px",
    },
    thumbnail: {
      width: "100%",
      height: "200px",
      borderRadius: "8px",
      cursor: "pointer",
      padding: "0px 0px",
    },
    videoDetails: {
      padding: "10px",
      color: "#fff",
    },
    videoTitle: {
      fontSize: "1rem",
      fontWeight: "bold",
      marginBottom: "5px",
    },
    videoSubtitle: {
      fontSize: "0.85rem",
      color: "#aaa",
    },
  };

  const sliderSettings = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1040,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const handleChangeVideo = (video) => {
    if (video?.url) {
      setVideoDetails(video);
      const urlObj = new URL(video.url);
      const videoId = urlObj.searchParams.get("v");

      if (player) {
        player.cueVideoById(videoId);
        window.scrollTo(0, 0);
      } else {
        loadYouTubePlayer(videoId);
      }
    }
  };

  useEffect(() => {
    if (num === 0) {
      let url;
      const sectionVideos = videoData[sectionTitle];
      if (Array.isArray(sectionVideos) && sectionVideos.length > 0) {
        url = sectionVideos[num];
      }
      handleChangeVideo(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [num, sectionTitle]);

  return (
    <>
      <div className="main-container">
        <div className="main-box">
          <div ref={iframeContainerRef} className="video-box"></div>
          <div className="video-list">
            <h3 className="details-title">{videoDetails?.title}</h3>
            <p className="details-subtitle">{videoDetails?.subtitle}</p>
            <p className="details-description">{videoDetails?.description}</p>
          </div>
        </div>
        <div style={styles.componentContainer}>
          {Object.entries(videoData).map(
            ([title, videos]) =>
              title === sectionTitle && (
                <div
                  className="section"
                  key={sectionTitle}
                  style={styles.section}
                  id={sectionTitle}
                >
                  <h2 style={styles.sectionTitle}>{sectionTitle}</h2>
                  <Slider {...sliderSettings}>
                    {videos.map((video) => (
                      <div
                        key={video.id}
                        onClick={() => handleChangeVideo(video)}
                      >
                        <div style={styles.maincard}>
                          <img
                            className="thumbnail"
                            src={video.thumbnail}
                            alt={video.title}
                            style={styles.thumbnail}
                          />
                          <div style={styles.videoDetails}>
                            <div style={styles.videoTitle}>{video.title}</div>
                            <div className="video-content">
                              {video.subtitle}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </Slider>
                </div>
              )
          )}
        </div>
        <QrLogin onLogin={isLoginVisible} onSkip={handleCloseLoginForm} />
      </div>
    </>
  );
};

export default YouTubeClone;
